import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { authFeatureService } from '../services/auth.feature.service'
import { authErrorMessage } from '../lib/authErrorMessage'
import type { SignInFormValues } from '../types'

export function useSignIn(returnTo = '/dashboard') {
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  async function signIn(values: SignInFormValues) {
    setError(null)
    setLoading(true)
    try {
      await authFeatureService.signIn(values)
      await navigate(returnTo)
    } catch (err) {
      setError(authErrorMessage(err, 'email-sign-in'))
    } finally {
      setLoading(false)
    }
  }

  return { signIn, error, loading, clearError: () => setError(null) }
}
